module.exports = __webpack_public_path__ + "img/mission.5b6c5bfe.jpg";